var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOverviewIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1.33337 4.33398C1.33337 2.67713 2.67652 1.33398 4.33337 1.33398C5.99023 1.33398 7.33337 2.67713 7.33337 4.33398V6.33398C7.33337 6.56648 7.33337 6.68272 7.30784 6.77812C7.23844 7.03692 7.03631 7.23905 6.77751 7.30845C6.68211 7.33398 6.56587 7.33398 6.33337 7.33398H4.33337C2.67652 7.33398 1.33337 5.99084 1.33337 4.33398Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66663 9.66602C8.66663 9.43355 8.66663 9.31728 8.69216 9.22188C8.76156 8.96308 8.96369 8.76095 9.22249 8.69155C9.31789 8.66602 9.43416 8.66602 9.66663 8.66602H11.6666C13.3235 8.66602 14.6666 10.0091 14.6666 11.666C14.6666 13.3229 13.3235 14.666 11.6666 14.666C10.0098 14.666 8.66663 13.3229 8.66663 11.666V9.66602Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33337 11.666C1.33337 10.0091 2.67652 8.66602 4.33337 8.66602H6.13337C6.55341 8.66602 6.76344 8.66602 6.92384 8.74775C7.06497 8.81968 7.17971 8.93442 7.25164 9.07555C7.33337 9.23595 7.33337 9.44595 7.33337 9.86602V11.666C7.33337 13.3229 5.99023 14.666 4.33337 14.666C2.67652 14.666 1.33337 13.3229 1.33337 11.666Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66663 4.33398C8.66663 2.67713 10.0098 1.33398 11.6666 1.33398C13.3235 1.33398 14.6666 2.67713 14.6666 4.33398C14.6666 5.99084 13.3235 7.33398 11.6666 7.33398H9.52376C9.42429 7.33398 9.37449 7.33398 9.33263 7.32925C8.98496 7.29012 8.71049 7.01565 8.67136 6.66798C8.66663 6.6261 8.66663 6.57635 8.66663 6.47684V4.33398Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverviewIcon);
export default __webpack_public_path__ + "static/media/overview-icon.2374d46f9001807472d7915a07106247.svg";
export { ForwardRef as ReactComponent };